export type NotificationLevel = 'success' | 'info' | 'warn' | 'error';

export class Notification {

  static error(message: string): Notification {
    return new Notification('error', message);
  }

  constructor(public level: NotificationLevel,
              public message: string,
              public id?: string,
  ) {
  }
}
